var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('HeaderBar'),_c('div',{staticClass:"content"},[_c('p',[_vm._v("Website under development, please excuse ugly style and broken/missing features as well as missing legal things.")]),_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }